<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Promotores"   />

    <Promotors />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Promotors from "@/components/Pages/Admin/Promotors/index.vue";

export default defineComponent({
  name: "CompaniesPage",
  components: {
    PageTitle,
    Promotors,
  },
});
</script>
